/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCommentAdd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-comment-add_svg__st0{fill:currentcolor}'}</style>
    <path className="ico-comment-add_svg__st0" d="M11 14h2v-3h3V9h-3V6h-2v3H8v2h3z" />
    <path
      className="ico-comment-add_svg__st0"
      d="M2 2v20h3.5l3-4H22V2H2zm18 14H7.5l-3 4H4V4h16v12z"
    />
  </Icon>
);
export { SvgCommentAdd as CommentAdd };
